import { Skeleton } from '@higo/ui';
import styled from 'styled-components';

export const MedicalOperatorNotesSkeleton = styled(Skeleton)`
  width: 100%;
  height: 10rem;
`;
